//@ts-nocheck
import { GetScriptsOutput } from '../../types'

export function getRebuttals(
  rebuttals: object,
  provider: 'ndr' | 'rga',
  payer: boolean,
  userRole: 'screener' | '*',
  lang: 'en' | 'es' = 'en',
): GetScriptsOutput {
  const key = `${lang}_${userRole === '*' ? '' : `${userRole.toLowerCase()}_`}${payer ? 'payer' : 'nonpayer'}_${provider}`

  return rebuttals[key] || {}
}
